import { Injectable } from '@angular/core';

import { Template } from '@site-mate/dashpivot-shared-library';

import { TemplatesService } from 'app/apps/templates.service';
import { FormulasVersion } from 'app/shared/service/formula-engine.service';

@Injectable({
  providedIn: 'root',
})
export class TemplateSettingsService {
  private currentEditingTemplate: Template = null;

  constructor(private readonly templatesService: TemplatesService) {}

  setCurrentEditingTemplate(template: Template) {
    this.currentEditingTemplate = template;
  }

  clearCurrentEditingTemplate() {
    this.currentEditingTemplate = null;
  }

  updateFormulasVersion(newVersion: FormulasVersion) {
    if (!this.currentEditingTemplate) {
      throw new Error('No template is currently being edited');
    }

    this.currentEditingTemplate.formulasVersion = newVersion;
    this.templatesService.currentOpenTemplateFormulasVersion.next(newVersion);
  }
}
